import React from 'react';
import { Box, RoundCloseIcon, Text } from '@common-fe/common-fe';

export const BadAddressChip = () => {
  return (
    <Box
      data-testId="bad-address-chip"
      pad={{ horizontal: 'spacing6', vertical: 'spacing4' }}
      border={{ size: 'small', color: 'dangerBorder' }}
      background="dangerContainer"
      round="container2Round"
      direction="row"
      align="center"
      alignSelf='start'
    >
      <RoundCloseIcon color="danger" size="16px" />
      <Text margin={{ left: 'spacing4' }} color="danger">
        Check undeliverable
      </Text>
    </Box>
  );
};
